import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-transfer',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './transfer.component.html',
  styleUrl: './transfer.component.scss'
})
export class TransferComponent {


  confirm() {
    Swal.fire({
      title: 'Confirmed',
      text: '₦4,800.00 has been received',
      icon: 'success',
      confirmButtonText: 'Done'
    })
    // Swal.fire('Confirmed', '₦4,800.00 has been received from you', 'success')
  }
}
